var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.68681 1.18965C7.66053 0.936784 7.33947 0.936784 7.31319 1.18965L7.09295 3.31096C6.80857 6.05015 4.91888 8.20979 2.52211 8.53481L0.665963 8.78651C0.444679 8.81654 0.444679 9.18346 0.665963 9.21349L2.52211 9.4652C4.91888 9.79021 6.80857 11.9499 7.09295 14.689L7.31319 16.8103C7.33947 17.0632 7.66053 17.0632 7.68681 16.8103L7.90704 14.689C8.19143 11.9499 10.0811 9.79021 12.4779 9.4652L14.3341 9.21349C14.5553 9.18346 14.5553 8.81654 14.3341 8.78651L12.4779 8.53481C10.0811 8.20979 8.19143 6.05015 7.90704 3.31096L7.68681 1.18965Z",
    fill: "#A3FBD4",
    stroke: "#020808"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/starIcon.e0b34d4d2dc96c6d8c81d28222baf8a5.svg";
export { ForwardRef as ReactComponent };